import React, { useState } from "react";
import { View, StyleSheet, TouchableOpacity, Animated } from "react-native";
import { MaterialCommunityIcons } from "@expo/vector-icons";

import config from "../config/config";
import AppText from "./AppText";
import { TouchableWithoutFeedback } from "react-native-gesture-handler";

function TabSelector({ tabs, onPress = () => {} }) {
    const [translateValue] = useState(new Animated.Value(0));
    const [selected, setSelected] = useState(tabs[0]);

    const [componentWidth, setComponentWidth] = useState(0);

    const handleSelected = (index) => {
        onPress(tabs[index]);

        setSelected(tabs[index]);

        Animated.spring(translateValue, {
            toValue: (componentWidth / tabs.length) * index,
            velocity: 5,
            useNativeDriver: true,
        }).start();
    };

    return (
        <View style={{ flexDirection: "row", justifyContent: "space-evenly" }} onLayout={(event) => setComponentWidth(event.nativeEvent.layout.width)}>
            <Animated.View
                style={[
                    {
                        position: "absolute",
                        backgroundColor: config.colors.tertiary,
                        borderRadius: 20,
                        transform: [{ translateX: translateValue }],
                        width: componentWidth / tabs.length - 10,
                        left: 5,
                        height: "100%",
                        alignSelf: "center",
                    },
                ]}
            />
            {tabs.map((tab, index) => (
                <TouchableWithoutFeedback key={tab.name} onPress={() => handleSelected(index, componentWidth)}>
                    <View style={{ width: componentWidth / tabs.length, alignItems: "center" }}>
                        <AppText
                            style={[{ fontWeight: "bold", textAlign: "center" }, selected.name == tab.name ? { color: config.colors.danger } : { color: config.colors.black }]}
                        >
                            {tab.name}
                        </AppText>
                    </View>
                </TouchableWithoutFeedback>
            ))}
        </View>
    );
}

const styles = StyleSheet.create({
    component: {
        flexDirection: "column",
        backgroundColor: config.colors.white,
        borderRadius: 20,
        shadowColor: config.colors.black,
        shadowOffset: { width: -2, height: 4 },
        shadowOpacity: 0.7,
        shadowRadius: 5,
        elevation: 10,
    },
});

export default TabSelector;
